import { render, staticRenderFns } from "./FormularioRedeSig.vue?vue&type=template&id=3b68f307&scoped=true&"
import script from "./FormularioRedeSig.vue?vue&type=script&lang=js&"
export * from "./FormularioRedeSig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68f307",
  null
  
)

export default component.exports